import React from "react";
import useFeature from "hooks/useFeature";
import InvestigationDrawer from "security-app/components/Investigations/Drawer";
import { useInvestigationDrawer } from "./InvestigationDrawer";
function InvestigationDrawerRenderer({ children }) {
  const isRightSidebarEnabled = useFeature("investigation_right_sidebar");
  const { showDrawer } = useInvestigationDrawer();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, !isRightSidebarEnabled && showDrawer && /* @__PURE__ */ React.createElement(InvestigationDrawer, null), children);
}
export default InvestigationDrawerRenderer;
